import { render } from "./FriendAddView.vue?vue&type=template&id=591abc09"
import script from "./FriendAddView.vue?vue&type=script&lang=js"
export * from "./FriendAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__